import { render, staticRenderFns } from "./CompleteInfo.vue?vue&type=template&id=2981b738"
import script from "./CompleteInfo.vue?vue&type=script&lang=js"
export * from "./CompleteInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports